<ng-container *ngIf="!productPage"><div class="bg-white rounded-[16px] border border-[#E5E8EC] md:pt-4 md:pb-5 md:px-4">
    <p
        class="text-[16px] font-medium text-black md:mb-2 ml-4 mt-4 md:ml-0 md:p-0"
    >
        {{ title || "" }}
    </p>

    <div class="hidden md:block">
        <table class="w-full">
            <thead>
                <tr class="text-left text-[#707D96] text-[14px] !font-medium">
                    <th>Supplier</th>
                    <th>Availability</th>
                    <th>Unit Price</th>
                    <th>MOV</th>
                    <th>Shipping Date</th>
                    <th class="text-right">Actions</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let variant of sortedVariants">
                    <tr *ngIf="variant.priceWithTax > 0 && variant.pricing">
                        <td>
                            <div
                                class="mt-4 text-black font-medium text-[16px]"
                            >
                                <a
                                    [routerLink]="[
                                        '/category/products',
                                        variant.pricing.id
                                    ]"
                                    class="hover:underline cursor-pointer"
                                    >{{ variant.pricing.id }}</a
                                >
                            </div>
                        </td>
                        <td>
                            <div
                                class="mt-4 text-black font-medium text-[16px]"
                            >
                                <span [class.text-red-600]="getAvailabilityDisplay(variant) === TEXT.OUT_OF_STOCK" [class.font-normal]="getAvailabilityDisplay(variant) === TEXT.OUT_OF_STOCK">
                                    {{ getAvailabilityDisplay(variant) }}
                                </span>
                            </div>
                        </td>
                        <td>
                            <div
                                class="mt-4 text-black font-medium text-[16px]"
                            >
                                {{ variant.priceWithTax | formatPrice }}
                            </div>
                        </td>
                        <td>
                            <div
                                class="mt-4 text-black font-medium text-[16px]"
                            >
                                {{ variant.pricing.mov | formatPrice }}
                            </div>
                        </td>
                        <td>
                            <div
                                class="mt-4 text-black font-medium text-[16px]"
                            >
                                {{ getShippingDateDisplay(variant) }}
                            </div>
                        </td>
                        <td>
                            <div class="actions-wrapper mt-4">
                                <div class="flex gap-4">
                                    <div
                                        class="w-[133px] flex h-[36px] items-center"
                                    >
                                        <button
                                            class="w-[60px] border-[#E5E8EC] flex justify-center border-[1px] rounded-l-[6px] h-full hover:bg-gray-200 bg-[#F9FAFB] border-r-transparent"
                                            (click)="decreaseQuantity(variant.id)"
                                        >
                                            <img
                                                src="../../../../assets/icons/minus-icon.svg"
                                                alt="Decrease Quantity"
                                                class="w-[20px]"
                                            />
                                        </button>
                                        <input
                                            type="text"
                                            class="h-[36px] bg-[#F9FAFB] border-l-transparent border-r-transparent border-b-[#E5E8EC] border-t-[#E5E8EC] w-full text-center text-[#707D96] text-[14px]"
                                            [value]="getQuantity(variant.id)"
                                            (input)="
                                                onQuantityChange(
                                                    $event.target.value,
                                                    variant.id
                                                )
                                            "
                                        />
                                        <button
                                            class="rounded-r-[6px] border-[#E5E8EC] border-[1px] bg-[#F9FAFB] w-[60px] h-full items-center flex justify-center hover:bg-gray-200 border-l-transparent"
                                            (click)="increaseQuantity(variant.id)"
                                        >
                                            <img
                                                src="../../../../assets/icons/plus-icon.svg"
                                                alt="Increase Quantity"
                                            />
                                        </button>
                                    </div>
                                    <button
                                        class="flex items-center justify-center w-[36px] h-[36px] bg-brand-primary text-white rounded border-[1px] border-brand-primary-strong hover:bg-brand-primary-hover"
                                        (click)="
                                            addToCart(
                                                variant,
                                                quantityMap[variant.id] || 1
                                            )
                                        "
                                    >
                                        <img
                                            alt="Add to Cart"
                                            src="../../../../assets/icons/cart-icon-white.svg"
                                            class="w-[24px] h-[24px]"
                                        />
                                    </button>
                                </div>
                                <span class="moq-text" *ngIf="!hasMinQ(variant) && getMoq(variant) > 1">
                                    {{ TEXT.MOQ_PREFIX }} {{ getMoq(variant) }} {{ TEXT.MOQ_SUFFIX }}
                                </span>
                                <span class="variant-table__quantity-info" *ngIf="hasMinQ(variant)">
                                    {{ getQuantityInfoText(variant) }}
                                </span>
                                <span class="variant-table__quantity-info" *ngIf="getBundleLabel(variant) as bundleLabel">
                                    {{ bundleLabel }}
                                </span>
                            </div>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>

    <div class="md:hidden space-y-4">
        <ng-container *ngFor="let variant of sortedVariants">
            <div
                *ngIf="variant.priceWithTax > 0 && variant.pricing"
                class="rounded-lg p-4 bg-white"
            >
                <div>
                    <div class="flex justify-between flex-col items-start mb-2">
                        <div class="flex justify-between w-full">
                            <div class="text-[#707D96] text-[14px] font-medium">
                                Supplier
                            </div>
                            <div
                                class="text-black font-medium text-[16px] mt-1 mb-2"
                            >
                                <a
                                    [routerLink]="[
                                        '/category/products',
                                        variant.pricing.id
                                    ]"
                                    class="hover:underline cursor-pointer"
                                    >{{ variant.pricing.id }}</a
                                >
                            </div>
                        </div>
                        <div class="flex justify-between w-full">
                            <div
                                class="text-[#707D96] text-[14px] font-medium mb-2"
                            >
                                Availability
                            </div>
                            <div
                                class="text-black font-medium text-[16px] mt-1 mb-2"
                            >
                                <span [class.text-red-600]="getAvailabilityDisplay(variant) === TEXT.OUT_OF_STOCK" [class.font-normal]="getAvailabilityDisplay(variant) === TEXT.OUT_OF_STOCK">
                                    {{ getAvailabilityDisplay(variant) }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="flex flex-col items-start">
                        <div class="flex justify-between w-full">
                            <div
                                class="text-[#707D96] text-[14px] font-medium mb-2"
                            >
                                Unit Price
                            </div>
                            <div
                                class="text-black font-medium text-[16px] mt-1 mb-2"
                            >
                                {{ variant.priceWithTax | formatPrice }}
                            </div>
                        </div>
                        <div class="flex justify-between w-full">
                            <div
                                class="text-[#707D96] text-[14px] font-medium mb-2"
                            >
                                MOV
                            </div>
                            <div
                                class="text-black font-medium text-[16px] mt-1 mb-2"
                            >
                                {{ variant.pricing.mov | formatPrice }}
                            </div>
                        </div>
                        <div class="flex justify-between w-full">
                            <div
                                class="text-[#707D96] text-[14px] font-medium mb-2"
                            >
                                Shipping Date
                            </div>
                            <div
                                class="text-black font-medium text-[16px] mt-1 mb-2"
                            >
                                {{ getShippingDateDisplay(variant) }}
                            </div>
                        </div>
                    </div>

                    <div class="actions-wrapper pt-2">
                        <div class="flex gap-4 items-center">
                            <div class="w-[133px] flex h-[36px] items-center">
                                <button
                                    class="w-[60px] border-[#E5E8EC] flex justify-center border-[1px] rounded-l-[6px] h-full hover:bg-gray-200 bg-[#F9FAFB] border-r-transparent"
                                    (click)="decreaseQuantity(variant.id)"
                                >
                                    <img
                                        src="../../../../assets/icons/minus-icon.svg"
                                        alt="Decrease Quantity"
                                        class="w-[20px]"
                                    />
                                </button>
                                <input
                                    type="text"
                                    class="h-[36px] bg-[#F9FAFB] border-l-transparent border-r-transparent border-b-[#E5E8EC] border-t-[#E5E8EC] w-full text-center text-[#707D96] text-[14px]"
                                    [value]="getQuantity(variant.id)"
                                    (input)="
                                        onQuantityChange(
                                            $event.target.value,
                                            variant.id
                                        )
                                    "
                                />
                                <button
                                    class="rounded-r-[6px] border-[#E5E8EC] border-[1px] bg-[#F9FAFB] w-[60px] h-full items-center flex justify-center hover:bg-gray-200 border-l-transparent"
                                    (click)="increaseQuantity(variant.id)"
                                >
                                    <img
                                        src="../../../../assets/icons/plus-icon.svg"
                                        alt="Increase Quantity"
                                    />
                                </button>
                            </div>
                            <button
                                class="flex items-center justify-center w-[36px] h-[36px] bg-brand-primary text-white rounded border-[1px] border-brand-primary-strong hover:bg-brand-primary-hover"
                                (click)="
                                    addToCart(variant, quantityMap[variant.id] || 1)
                                "
                            >
                                <img
                                    alt="Add to Cart"
                                    src="../../../../assets/icons/cart-icon-white.svg"
                                    class="w-[24px] h-[24px]"
                                />
                            </button>
                        </div>
                        <span class="moq-text" *ngIf="!hasMinQ(variant) && getMoq(variant) > 1">
                            {{ TEXT.MOQ_PREFIX }} {{ getMoq(variant) }} {{ TEXT.MOQ_SUFFIX }}
                        </span>
                        <span class="variant-table__quantity-info" *ngIf="hasMinQ(variant)">
                            {{ getQuantityInfoText(variant) }}
                        </span>
                        <span class="variant-table__quantity-info" *ngIf="getBundleLabel(variant) as bundleLabel">
                            {{ bundleLabel }}
                        </span>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
</ng-container>
<section *ngIf="productPage" class="offer-table" [class.offer-table--lowest]="title">
    <header *ngIf="title"><h2>{{ title }} <span class="pdp-info" title="Prices may be subject to VAT.">i</span></h2><span>{{ totalAvailable | number }} <span class="offer-table__desktop-word">available</span><span class="offer-table__mobile-word">avail.</span></span></header>
    <div class="offer-table__labels" *ngIf="title"><span>Supplier</span><div class="offer-table__price-labels"><span>Unit price</span><span>MOV</span></div><span>Stock</span><span>Actions</span></div>
    <article class="offer-row" *ngFor="let variant of sortedVariants" [class.offer-row--expanded]="expandedOffers.has(variant.id)">
        <button type="button" class="offer-row__summary" [attr.aria-expanded]="expandedOffers.has(variant.id)" (click)="toggleOffer(variant.id)"><strong class="offer-row__summary-supplier">{{ variant.pricing.id }}</strong><strong>{{ priceTiers(variant)[0].price / 100 | currency:(variant.pricing.currency || 'EUR'):'symbol':'1.2-2' }}</strong><small>MOV {{ priceTiers(variant)[0].mov / 100 | currency:(variant.pricing.currency || 'EUR'):'symbol':'1.0-0' }}</small></button>
        <div class="offer-row__supplier"><a [routerLink]="['/category/products', variant.pricing.id]">{{ variant.pricing.id }} <svg class="pdp-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><use href="assets/icons/pdp-sprite.svg#external"></use></svg></a><small class="offer-row__delivery" [class.offer-row__available]="!isPreOrder(variant) && getAvailableQuantity(variant) > 0"><svg class="pdp-icon" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><use [attr.href]="'assets/icons/pdp-sprite.svg#' + (isPreOrder(variant) ? 'truck' : 'check')"></use></svg>{{ isPreOrder(variant) ? 'Estimated delivery: ' + getShippingDateDisplay(variant) : getAvailableQuantity(variant) > 0 ? 'In stock' : 'Out of stock' }}</small><small class="offer-row__preorder" *ngIf="isPreOrder(variant)">Pre-order<span *ngIf="variant.pricing.prePaymentPercentage != null"> · {{ variant.pricing.prePaymentPercentage }}% pre-payment</span></small><small class="offer-row__mobile-availability" [class.offer-row__available]="!isPreOrder(variant) && getAvailableQuantity(variant) > 0">{{ isPreOrder(variant) ? 'Pre-order · ' + getShippingDateDisplay(variant) : getAvailableQuantity(variant) > 0 ? 'In stock' : 'Out of stock' }}</small></div>
        <div class="offer-row__prices"><div class="offer-row__break-heading">Price breaks by order value</div><div class="offer-row__mobile-price-labels"><span>Unit price</span><span>Min. order value</span></div><ng-container *ngFor="let tier of priceTiers(variant); trackBy: trackPriceTier"><strong>{{ tier.price / 100 | currency:(variant.pricing.currency || 'EUR'):'symbol':'1.2-2' }}</strong><span>{{ tier.mov / 100 | currency:(variant.pricing.currency || 'EUR'):'symbol':'1.0-0' }}</span></ng-container></div>
        <div class="offer-row__stock"><span class="offer-row__mobile-mov">MOV {{ priceTiers(variant)[0].mov / 100 | currency:(variant.pricing.currency || 'EUR'):'symbol':'1.0-0' }} · </span>{{ getAvailableQuantity(variant) | number }}<span class="offer-row__mobile-word"> avail.</span><small *ngIf="variant.pricing.isDamagedPackaging" class="offer-row__condition">Damaged packaging</small><small *ngIf="variant.pricing.isDecoded" class="offer-row__condition offer-row__condition--neutral">Decoded</small><small *ngIf="variant.pricing.isShortBbd" class="offer-row__condition">Short-dated</small></div>
        <div class="offer-row__actions"><div class="offer-row__controls"><div class="offer-row__quantity"><button type="button" aria-label="Decrease quantity" (click)="decreaseQuantity(variant.id)">−</button><input type="number" aria-label="Order quantity" [min]="getMinQ(variant)" [value]="getQuantity(variant.id)" (change)="onQuantityChange($event.target.value, variant.id)" /><button type="button" aria-label="Increase quantity" (click)="increaseQuantity(variant.id)">+</button></div><button type="button" class="offer-row__cart" aria-label="Add to cart" [disabled]="busy" (click)="addToCart(variant, getQuantity(variant.id))"><svg class="pdp-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><use href="assets/icons/pdp-sprite.svg#cart"></use></svg><span>Add to cart</span></button></div><small *ngIf="getMinQ(variant) > 1 || getMaxQ(variant)">{{ variant.pricing.fullPackageOnly ? 'Bundles of ' + getMinQ(variant) : getQuantityInfoText(variant) }}</small></div>
    </article>
</section>
